/**
 * Registers a new block provided a unique name and an object defining its behavior.
 *
 * @see https://developer.wordpress.org/block-editor/developers/block-api/#registering-a-block
 */
import { registerBlockType } from '@wordpress/blocks';
import { __ } from '@wordpress/i18n';
import { ReactComponent as BlockplayerBlock } from '../../assets/icons/blockplayer-block.svg';
import Attributes from './attributes';
import deprecated from './deprecated';
/**
 * Internal dependencies
 */
import Edit from './edit';
import save from './save';
import './style/slider.sass';
/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * All files containing `style` keyword are bundled together. The code used
 * gets applied both to the front of your site and to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './style/style.sass';

/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/developers/block-api/#registering-a-block
 */

registerBlockType( 'blockplayer/guten-player', {
	$schema: "https://schemas.wp.org/trunk/block.json",
	apiVersion: 2,
    title: __('Video Player'), 
    description: __( 'BlockPlayer - Play Video From Anywhere', 'blockplayer' ),
    category: 'blockplayer',
    keywords: [
        __( 'video player', 'blockplayer' ),
        __( 'video', 'blockplayer' ),
        __( 'player', 'blockplayer' ),
        __( 'mp4', 'blockplayer' ),
        __( 'webm', 'blockplayer' ),
        __( 'ogv', 'blockplayer' ),
        __( 'hls', 'blockplayer' ),
        __( 'dash', 'blockplayer' ),
    ],
    icon: <BlockplayerBlock/>,
    supports: {
        align: [ 'center', 'wide', 'full' ]
    },
    example: {
        attributes: {
            url: 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4',
            playing: true
        },
    },
    attributes: Attributes,
	/**
	 * @see ./edit.js
	 */
	edit: Edit,

	/**
	 * @see ./save.js
	 */
	save,
    deprecated
} );